import React from "react";
import Header from "../components/common/Header";
import UploadTests from "../components/UploadTests";

const UploadTestsPage = () => {
  return (
    <div className="page-container">
      <div className="content-card">
        <UploadTests />
      </div>
    </div>
  );
};

export default UploadTestsPage;
